import { Observable } from 'rxjs'
import { UserTypeGateway } from './user-type-gateway'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

@Injectable()
export class NetworkUserTypeGateway extends UserTypeGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getAllUserType(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetUserTypes'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getAllOrganization(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetOrganizationsForUser'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getAllUserProfileStatus(retrieveAll: boolean): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetUserProfileStatus/' + retrieveAll
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getAllStatusReasons(listID: number): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetListDataByID/' + listID
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
    getFMO(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/getParents'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getUserBasedRole(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetUserBasedRole/'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
}
